// btw-front/src/components/dev/RoleSwitcher.jsx
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { usePartnerSession } from "../../context/PartnerSessionContext";

const ROLES = ["guest", "pending", "partner", "admin"];

const ICON = {
  guest: "👤",
  pending: "⏳",
  partner: "🤝",
  admin: "🛡️",
};

// 노출 조건 — 둘 다 빌드 타임 상수(webpack DefinePlugin 치환):
//   1) 개발 모드 (npm start, NODE_ENV=development)
//   2) 빌드 시 REACT_APP_INCLUDE_DEV_UI=true 주입 (dev 배포 워크플로)
// 운영 빌드는 두 조건 모두 상수 false 로 접혀 minifier 가 RoleSwitcherInner 까지
// 번들에서 실제 제거한다. (런타임 호스트명 검사를 섞으면 코드가 운영 번들에 남으므로 금지)
// 주의: DefinePlugin 은 '정의된' env 만 치환하므로 운영 워크플로(front-deploy.yml)가
// REACT_APP_INCLUDE_DEV_UI=false 를 명시 주입해야 제거가 동작한다. 미정의면 코드 잔존.
const INCLUDE_DEV_UI =
  process.env.NODE_ENV !== "production" || process.env.REACT_APP_INCLUDE_DEV_UI === "true";

export default function RoleSwitcher() {
  if (!INCLUDE_DEV_UI) return null;
  return <RoleSwitcherInner />;
}

function RoleSwitcherInner() {
  const { t } = useTranslation();
  const { role, setRole, clearSignupToken } = usePartnerSession();
  const [open, setOpen] = useState(false);

  function pick(next) {
    setRole(next);
    clearSignupToken();
    setOpen(false);
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 select-none">
      {open && (
        <div className="mb-2 w-56 rounded-xl border border-slate-200 bg-white p-2 shadow-lg">
          <div className="px-2 pb-1 text-[11px] font-semibold uppercase tracking-wider text-slate-400">
            {t("dev.roleSwitcher.label")}
          </div>
          <ul className="grid gap-0.5">
            {ROLES.map((r) => (
              <li key={r}>
                <button
                  type="button"
                  onClick={() => pick(r)}
                  className={`flex w-full items-center gap-2 rounded-lg px-2 py-1.5 text-left text-sm transition ${
                    role === r ? "bg-accent/10 text-accent" : "text-slate-700 hover:bg-slate-50"
                  }`}
                >
                  <span aria-hidden="true">{ICON[r]}</span>
                  <span>{t(`dev.roleSwitcher.options.${r}`)}</span>
                </button>
              </li>
            ))}
          </ul>
          <div className="mt-1 border-t border-slate-100 px-2 pt-1.5 text-[10px] text-slate-400">
            {t("dev.roleSwitcher.hint")}
          </div>
        </div>
      )}
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 rounded-full border border-slate-300 bg-white px-3 py-2 text-xs font-medium text-slate-700 shadow-md hover:border-accent hover:text-accent"
      >
        <span aria-hidden="true">{ICON[role]}</span>
        <span>{t(`dev.roleSwitcher.options.${role}`)}</span>
        <span className="text-slate-400">▾</span>
      </button>
    </div>
  );
}
